import React from "react";
import { css } from "@emotion/react";
import Card from "components/Card";
import { FormattedMessage } from "react-intl";
import { PrimaryLink } from "components/Links";
import DisplayBox from "components/DisplayBox";
import { MATCHING_EMAIL } from "constants/index";

/**
 * ApplicantContactUs
 * This component displays a message asking the user if they need support
 */
const ApplicantContactUs = () => (
  <Card>
    <DisplayBox
      title={<FormattedMessage id="Global.NeedSupportQuestion" />}
      numColumns={1}
      data={[
        {
          message: (
            <div css={styles.contactUsContainer}>
              <FormattedMessage
                id="Global.ContactUs"
                values={{
                  link: (
                    <PrimaryLink css={styles.contactUsEmail} href={`mailto:${MATCHING_EMAIL}`} target="_blank">
                      <FormattedMessage id="Global.MatchingEmail" />
                    </PrimaryLink>
                  ),
                }}
              />
            </div>
          ),
        },
      ]}
      itemRenderer={({ message }) => message}
    />
  </Card>
);

const styles = {
  contactUsContainer: css`
    display: flex;
    flex-direction: row;
    margin-top: 5px;
  `,
  contactUsEmail: css`
    margin-left: 3px;
  `,
};

export default ApplicantContactUs;
